// Where the retirement notices send people. No shutdown date on purpose: it depends on how fast clients move (Nick, 2026-10-22).
export const NEW_DASHBOARD_URL = 'https://app.streamforge.com'
export const SUPPORT_EMAIL = 'hello@streamforge.com'
